<template>
  <transition name="klick-modal">
    <div :class="modalTypeClass" class="klick-modal-mask">
      <div class="klick-modal-wrapper c-modal__wrapper u-scroll">
        <button v-if="showCloseButton" class="c-modal__close" @click="$emit('close')">
          <i class="c-icon--close"></i>
        </button>

        <div class="c-modal__body">
          <slot name="body"></slot>
        </div>

        <slot name="footer"></slot>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  props: {
    showCloseButton: {
      type: Boolean,
      required: false,
      default: true,
    },
    modalType: {
      type: String,
      required: false,
      default: '',
    },
  },
  computed: {
    modalTypeClass() {
      const modalClass = 'c-modal';

      if (this.modalType) {
        return `${modalClass}--${this.modalType}`;
      }

      return modalClass;
    },
  },
};
</script>

<style scoped>
  .klick-modal-mask {
    width: 100%;
    background: rgba(255, 255, 255, .5);
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
  }
</style>



// WEBPACK FOOTER //
// GeneralLayout.vue?1daac1b1